import { StringKey } from '../../../../lang/index';

export enum SignatureStatus {
  ALL = 'all',
  DOCUMENT_EXPIRED = 'document-expired',
  FULLY_SIGNED = 'fully-signed',
  PARTIALLY_SIGNED = 'partially-signed',
  SIGNATURE_PENDING = 'signature-pending',
  VOIDED = 'voided',
}

export const signatureStatusFilterMap: SignatureStatus[] = [
  SignatureStatus.ALL,
  SignatureStatus.FULLY_SIGNED,
  SignatureStatus.PARTIALLY_SIGNED,
  SignatureStatus.SIGNATURE_PENDING,
  SignatureStatus.DOCUMENT_EXPIRED,
  SignatureStatus.VOIDED,
];

export const signatureStatusTranslationKey: Record<SignatureStatus, StringKey> = {
  [SignatureStatus.ALL]: 'FILTER_ALL',
  [SignatureStatus.DOCUMENT_EXPIRED]: 'SIGNATURE_STATUS_DOCUMENT_EXPIRED',
  [SignatureStatus.FULLY_SIGNED]: 'SIGNATURE_STATUS_FULLY_SIGNED',
  [SignatureStatus.PARTIALLY_SIGNED]: 'SIGNATURE_STATUS_PARTIALLY_SIGNED',
  [SignatureStatus.SIGNATURE_PENDING]: 'SIGNATURE_STATUS_SIGNATURE_PENDING',
  [SignatureStatus.VOIDED]: 'SIGNATURE_STATUS_VOIDED',
};
